import { defineMessages } from 'react-intl'

const translations = defineMessages({
  headline: {
    defaultMessage: 'My Data',
    id: 'global.account.link.my_account_data'
  },
  birthDate: {
    defaultMessage: 'Birth date: {date}',
    id: 'msp.account.my_account_details.birthdate'
  },
  telephone: {
    defaultMessage: 'Tel: {telephone}',
    id: 'msp.account.my_account_details.telephone'
  },
  phoneHome: {
    defaultMessage: 'Home phone: {telephone}',
    id: 'msp.account.my_account_details.telephone.home'
  },
  phoneMobile: {
    defaultMessage: 'Mobile phone: {telephone}',
    id: 'msp.account.my_account_details.telephone.mobile'
  },
  phoneBusiness: {
    defaultMessage: 'Business phone: {telephone}',
    id: 'msp.account.my_account_details.telephone.business'
  },
  email: {
    defaultMessage: 'E-Mail: {email}',
    id: 'msp.account.my_account_details.email'
  }
})

export default translations
